import firebase from 'firebase/app';

const auth = () => firebase.auth();

auth.getClaims = () => new Promise((resolve, reject) => {
  firebase.auth().onAuthStateChanged((user) => {
    if (user) {
      user.getIdTokenResult().then((idTokenResult) => {
        resolve(idTokenResult.claims);
      }).catch((error) => {
        reject(error);
      });
    } else {
      resolve(null);
    }
  }, (error) => {
    reject(error);
  });
});

auth.signInWithCustomToken = token => firebase.auth().signInWithCustomToken(token);

export default auth;
